import { INIT_CHANNEL_PAGE_DATA, INIT_DISCOUNT_EXTENDPO, CHANNEL_C_GROUPING_LIST } from '../../actions/modules/ModulesActionsChannel';

/**
 * 初始化STATE
 */
export const initialState: any = {
	channelInfo: {},
	desc: {},
	chargeConfigs: [],
	autoShareInfo: {},
	marketingInfo: {},
	channelId: '',
	liveId: '',
	groupingList: [],
	myGroupInfo: {},
	channelCouponStatus: {},
	// 当前选中的优惠券
	curCoupon: null,

	myShareQualify: {},
};

/**
 * channel
 */
function channel(state: any = initialState, action: any): any {
	const { type, item } = action;

	switch (type) {
		case INIT_CHANNEL_PAGE_DATA:
			return {
				...state,
				...action.pageData,
			};
		case INIT_DISCOUNT_EXTENDPO:
			return { ...state, discountExtendPo: action.discountExtendPo };
		case CHANNEL_C_GROUPING_LIST:
			return {
				...state,
				groupingList: action.groupingList,
			};
		default: {
			return state;
		}
	}
}

export default channel;
